export { default } from './PatientReferralHeader';
